/* ============ LILAVÉ — Motion ============ */
(function () {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    || location.search.includes("nomotion");
  if (reduceMotion) {
    document.documentElement.classList.add("no-motion");
    const at = new URLSearchParams(location.search).get("at");
    if (at) {
      // Screenshot-Modus: Inhalt verschieben statt scrollen (headless captured immer bei 0)
      document.body.style.transform = "translateY(-" + parseInt(at, 10) + "px)";
    }
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  /* ---------- Natives Scrollen (kein Smooth-Scroll-Framework) ---------- */
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  // Anchor links nativ mit Offset (scroll-margin-top im CSS)
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener("click", (e) => {
      const target = document.querySelector(a.getAttribute("href"));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });


  /* ---------- Split headlines into chars ---------- */
  document.querySelectorAll("[data-split]").forEach((el) => {
    const text = el.textContent;
    el.setAttribute("aria-label", text);
    el.textContent = "";
    text.split(" ").forEach((word, wi, arr) => {
      const wordSpan = document.createElement("span");
      wordSpan.className = "word";
      wordSpan.setAttribute("aria-hidden", "true");
      word.split("").forEach((ch) => {
        const span = document.createElement("span");
        span.className = "char";
        span.textContent = ch;
        wordSpan.appendChild(span);
      });
      el.appendChild(wordSpan);
      if (wi < arr.length - 1) el.appendChild(document.createTextNode(" "));
    });
  });

  /* ---------- Hero intro timeline ---------- */
  const heroTl = gsap.timeline({ defaults: { ease: "expo.out" } });
  heroTl
    .from(".hero__title .char", {
      yPercent: 120, opacity: 0, rotateX: -40,
      duration: 1.1, stagger: 0.028, delay: 0.15,
    })
    .to(".hero .reveal-up", { opacity: 1, y: 0, duration: 0.9, stagger: 0.12 }, "-=0.7");

  /* ---------- Hero bottle float + parallax ---------- */
  gsap.to("#heroBottle", {
    y: -14, duration: 3, ease: "sine.inOut", yoyo: true, repeat: -1,
  });
  gsap.to(".hero__visual", {
    yPercent: 12, ease: "none",
    scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true },
  });
  gsap.to(".hero__text", {
    yPercent: -8, opacity: 0.25, ease: "none",
    scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true },
  });

  /* ---------- Progress bar ---------- */
  gsap.to(".progress-bar", {
    scaleX: 1, ease: "none",
    scrollTrigger: { start: 0, end: "max", scrub: 0.3 },
  });

  /* ---------- Nav hide on scroll down ---------- */
  let lastY = 0;
  const nav = document.querySelector(".nav");
  window.addEventListener("scroll", () => {
    const scroll = window.scrollY;
    if (scroll > 140 && scroll > lastY + 4) nav.classList.add("nav--hidden");
    else if (scroll < lastY - 4) nav.classList.remove("nav--hidden");
    lastY = scroll;
  }, { passive: true });

  /* ---------- Generic reveals (outside hero) ---------- */
  document.querySelectorAll(".reveal-up").forEach((el) => {
    if (el.closest(".hero")) return;
    gsap.to(el, {
      opacity: 1, y: 0, duration: 1, ease: "expo.out",
      scrollTrigger: { trigger: el, start: "top 86%" },
    });
  });

  /* ---------- Section titles: char stagger on scroll ---------- */
  document.querySelectorAll(".section-title[data-split], .cta-final__title[data-split]").forEach((el) => {
    gsap.from(el.querySelectorAll(".char"), {
      yPercent: 110, opacity: 0, duration: 0.9, ease: "expo.out", stagger: 0.018,
      scrollTrigger: { trigger: el, start: "top 85%" },
    });
  });

  /* ---------- Step cards + ingredient cards stagger ---------- */
  [[".steps__grid", ".step-card"], [".ing__grid", ".ing-card"]].forEach(([wrap, item]) => {
    gsap.from(item, {
      y: 60, opacity: 0, duration: 1, ease: "expo.out", stagger: 0.12,
      scrollTrigger: { trigger: wrap, start: "top 82%" },
    });
  });

  /* ---------- Color wheel: rotate on scroll ---------- */
  gsap.to(".wheel-rotor", {
    rotation: 200, transformOrigin: "150px 150px", ease: "none",
    scrollTrigger: { trigger: ".theory", start: "top bottom", end: "bottom top", scrub: 1 },
  });
  gsap.from(".theory__wheel", {
    scale: 0.8, opacity: 0, duration: 1.2, ease: "expo.out",
    scrollTrigger: { trigger: ".theory", start: "top 75%" },
  });

  /* ---------- Scroll-scrub video (the hero move) ---------- */
  const stage = document.querySelector(".scrub__stage");
  const vid = document.querySelector(".scrub__video");
  const scrim = document.querySelector(".scrub__scrim");
  const intro = document.querySelector(".scrub__intro");
  const words = gsap.utils.toArray(".scrub-word");
  const progressFill = document.querySelector(".scrub__progress-fill");

  let targetTime = 0;
  let currentTime = 0;

  if (stage && vid) {

  const videoReady = () => vid.readyState >= 2 && vid.duration > 0;

  // Lazy-Load: richtige Grösse wählen, laden erst wenn die Sektion naht
  const scrubSrc = (isMobile ? vid.dataset.srcMobile : vid.dataset.srcDesktop)
    || vid.dataset.srcDesktop || vid.currentSrc;
  const loadScrub = () => {
    if (!vid.src && scrubSrc) { vid.src = scrubSrc; vid.load(); }
  };
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { loadScrub(); io.disconnect(); }
    }, { rootMargin: "150% 0px" });
    io.observe(stage);
  } else {
    loadScrub();
  }

  function stageProgress() {
    const rect = stage.getBoundingClientRect();
    const total = rect.height - window.innerHeight;
    return Math.min(1, Math.max(0, -rect.top / total));
  }

  function onScrub() {
    const p = stageProgress();

    if (videoReady()) targetTime = p * vid.duration;

    // Intro text: visible in the first ~22%
    const introP = Math.min(1, p / 0.22);
    intro.style.opacity = String(1 - introP);
    intro.style.transform = `translateY(${introP * -40}px)`;

    // Scrim from ~45%
    scrim.style.opacity = String(Math.min(1, Math.max(0, (p - 0.45) / 0.2)));

    // Words: staggered ins
    words.forEach((w) => {
      const start = parseFloat(w.dataset.start);
      const wp = Math.min(1, Math.max(0, (p - start) / 0.09));
      w.style.opacity = String(wp);
      w.style.transform = `translateY(${(1 - wp) * 36}px) scale(${0.96 + wp * 0.04})`;
    });

    progressFill.style.transform = `scaleX(${p})`;
  }

  // Lerp the video time for buttery seeking
  gsap.ticker.add(() => {
    onScrub();
    if (videoReady() && Math.abs(targetTime - currentTime) > 0.001) {
      currentTime += (targetTime - currentTime) * 0.3;
      try { vid.currentTime = currentTime; } catch (e) { /* seek not ready */ }
    }
  });

  } // Ende Scrub-Guard

  /* ---------- Counters ---------- */
  document.querySelectorAll(".num-count").forEach((el) => {
    const end = parseInt(el.dataset.count, 10);
    const suffix = el.dataset.suffix || "";
    const useK = el.dataset.format === "k";
    const obj = { v: 0 };
    el.textContent = "0";
    gsap.to(obj, {
      v: end, duration: 2, ease: "expo.out",
      scrollTrigger: { trigger: el, start: "top 88%" },
      onUpdate() {
        let val = Math.round(obj.v);
        let txt = useK && val >= 1000 ? Math.round(val / 1000) + "'000" : val.toLocaleString("de-CH");
        el.textContent = txt + suffix;
      },
    });
  });

  /* ---------- Before/After slider ---------- */
  const baWrap = document.getElementById("baWrap");
  const baClip = document.getElementById("baClip");
  const baHandle = document.getElementById("baHandle");
  if (baWrap) {
    let dragging = false;
    const setBA = (clientX) => {
      const rect = baWrap.getBoundingClientRect();
      const x = Math.min(rect.width, Math.max(0, clientX - rect.left));
      const pct = (x / rect.width) * 100;
      baClip.style.width = pct + "%";
      baHandle.style.left = pct + "%";
      baHandle.setAttribute("aria-valuenow", String(Math.round(pct)));
    };
    baWrap.addEventListener("pointerdown", (e) => { dragging = true; setBA(e.clientX); });
    window.addEventListener("pointermove", (e) => { if (dragging) setBA(e.clientX); });
    window.addEventListener("pointerup", () => { dragging = false; });
    baHandle.addEventListener("keydown", (e) => {
      const now = parseFloat(baHandle.style.left || "50");
      const rect = baWrap.getBoundingClientRect();
      if (e.key === "ArrowLeft") setBA(rect.left + ((now - 4) / 100) * rect.width);
      if (e.key === "ArrowRight") setBA(rect.left + ((now + 4) / 100) * rect.width);
    });
    // Little attract animation once in view
    gsap.fromTo(baClip, { width: "50%" }, {
      width: "62%", duration: 1.1, ease: "sine.inOut", yoyo: true, repeat: 1,
      scrollTrigger: { trigger: baWrap, start: "top 75%" },
      onUpdate() { baHandle.style.left = baClip.style.width; },
    });
  }

  /* ---------- 3D tilt on ingredient cards ---------- */
  document.querySelectorAll(".tilt").forEach((card) => {
    card.addEventListener("pointermove", (e) => {
      const r = card.getBoundingClientRect();
      const rx = ((e.clientY - r.top) / r.height - 0.5) * -10;
      const ry = ((e.clientX - r.left) / r.width - 0.5) * 10;
      gsap.to(card, { rotateX: rx, rotateY: ry, scale: 1.03, duration: 0.4, ease: "power2.out", transformPerspective: 700 });
    });
    card.addEventListener("pointerleave", () => {
      gsap.to(card, { rotateX: 0, rotateY: 0, scale: 1, duration: 0.6, ease: "expo.out" });
    });
  });

  /* ---------- Magnetic buttons ---------- */
  document.querySelectorAll(".magnetic").forEach((btn) => {
    btn.addEventListener("pointermove", (e) => {
      const r = btn.getBoundingClientRect();
      gsap.to(btn, {
        x: (e.clientX - r.left - r.width / 2) * 0.25,
        y: (e.clientY - r.top - r.height / 2) * 0.35,
        duration: 0.4, ease: "power2.out",
      });
    });
    btn.addEventListener("pointerleave", () => {
      gsap.to(btn, { x: 0, y: 0, duration: 0.7, ease: "elastic.out(1, 0.4)" });
    });
  });

  /* ---------- FAQ smooth open ---------- */
  document.querySelectorAll(".faq-item").forEach((item) => {
    const content = item.querySelector("p");
    item.querySelector("summary").addEventListener("click", () => {
      if (!item.open) {
        requestAnimationFrame(() => {
          gsap.from(content, { opacity: 0, y: -8, duration: 0.45, ease: "power2.out" });
        });
      }
    });
  });
})();

/* ============ Warenkorb-Drawer ============ */
(function () {
  var drawer = document.getElementById("cartDrawer");
  var toggle = document.getElementById("cartToggle");
  if (!drawer || !toggle) return;
  var itemsEl = document.getElementById("cartItems");
  var totalEl = document.getElementById("cartTotal");
  var countEl = document.getElementById("cartCount");

  var currency = "CHF";
  function fmt(cents) {
    try {
      return new Intl.NumberFormat("de-CH", { style: "currency", currency: currency }).format(cents / 100);
    } catch (e) {
      return currency + " " + (cents / 100).toFixed(2);
    }
  }

  function render(cart) {
    if (cart.currency) currency = cart.currency;
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.hidden = cart.item_count === 0;
    }
    totalEl.textContent = fmt(cart.items_subtotal_price);
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="cartd__empty">Dein Warenkorb ist leer.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (it, i) {
      var title = it.product_title + (it.variant_title && it.variant_title !== "Default Title" ? " · " + it.variant_title : "");
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_160x$1$2") : "";
      return '<div class="cartd__item">' +
        (img ? '<img src="' + img + '" alt="" width="64" height="64">' : "") +
        '<div class="cartd__item-info"><strong>' + title + "</strong>" +
        (it.selling_plan_allocation ? '<small style="display:block;color:#a78bfa;font-size:12px;margin-top:2px">' + it.selling_plan_allocation.selling_plan.name + '</small>' : '') +
        '<div class="cartd__qty">' +
        '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Weniger">−</button>' +
        "<span>" + it.quantity + "</span>" +
        '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Mehr">+</button>' +
        '<button type="button" class="cartd__remove" data-line="' + (i + 1) + '" data-qty="0">Entfernen</button>' +
        "</div></div>" +
        '<span class="cartd__item-price">' + fmt(it.final_line_price) + "</span>" +
        "</div>";
    }).join("");
  }

  function refresh() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(render);
  }

  function openDrawer() {
    refresh().then(function () {
      drawer.classList.add("cartd--open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    });
  }
  function closeDrawer() {
    drawer.classList.remove("cartd--open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  toggle.addEventListener("click", openDrawer);

  // Kaufen-Formulare: in den Warenkorb legen und Drawer aufschieben (statt Checkout)
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      fetch("/cart/add.js", { method: "POST", body: new FormData(f) })
        .then(function (r) { return r.json(); })
        .then(function () { openDrawer(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  });
  document.getElementById("cartClose").addEventListener("click", closeDrawer);
  document.getElementById("cartOverlay").addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  itemsEl.addEventListener("click", function (e) {
    var btn = e.target.closest("button[data-line]");
    if (!btn) return;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: parseInt(btn.dataset.qty, 10) }),
    }).then(function (r) { return r.json(); }).then(render);
  });
})();
